import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class GzTabWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  public label = '';

  @property({ type: Boolean, attribute: true, reflect: true })
  public selected = false;

  @property({ type: Boolean, reflect: true })
  disabled = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  public hidden = false;

  @property({ type: String, attribute: true, reflect: true })
  public route = '';

  public static get styles() {
    return styles;
  }

  public render() {
    return html`
      <div
        class="gz-tab-wrap ${this.selected ? 'tab-selected' : 'tab-not-selected'} ${this.hidden
          ? 'tab-hidden'
          : 'tab-visible'}"
      >
        <slot></slot>
      </div>
    `;
  }
}
